import { onMounted, onUnmounted, type Ref } from "vue";
import type { Tool } from "@/features/draw/types";

export function useEventHandlers(
  selectedTool: Ref<Tool>,
  handleUndo: () => void,
  handleRedo: () => void,
  onToolChange: (tool: Tool) => void
) {
  const handleKeyboard = (event: KeyboardEvent) => {
    // Skip if we're in an input field
    if (
      event.target instanceof HTMLInputElement ||
      event.target instanceof HTMLTextAreaElement
    ) {
      return;
    }

    const isCmdOrCtrl = event.metaKey || event.ctrlKey;

    if (isCmdOrCtrl && event.key === "z") {
      event.preventDefault();
      if (!event.shiftKey) {
        handleUndo();
      }
      return;
    }

    if (event.key === "z") {
      event.preventDefault();
      handleRedo();
      return;
    }

    // Tool shortcuts
    const key = event.key.toLowerCase();

    switch (key) {
      case "b":
        event.preventDefault();
        onToolChange("brush");
        break;
      case "e":
        event.preventDefault();
        onToolChange("eraser");
        break;
      case "g":
        event.preventDefault();
        onToolChange("fill");
        break;
      case "i":
        event.preventDefault();
        onToolChange("eyedropper");
        break;
    }
  };

  onMounted(() => {
    window.addEventListener("keydown", handleKeyboard);
  });

  onUnmounted(() => {
    window.removeEventListener("keydown", handleKeyboard);
  });

  return {
    handleKeyboard,
  };
}
